<template>
  <div class="login-container" style="min-height: calc(100vh - 180px); position: relative;">
    <!-- 置頂頭部 -->
    <div class="header-container" style="position: fixed; top: 0; left: 0; width: 100%; z-index: 1000;">
      <div style="padding: 16px 20px; background-color: #fff; display: flex; align-items: center; justify-content: space-between;">
        <!-- 左側返回按鈕 -->
        <div style="display: flex; align-items: center; cursor: pointer;" @click.stop="goHome">
          <img src="../assets/fanhui.png" alt="" style="width: 20px; height: 20px; filter: invert(30%);">
          <div style="font-size: 24px; letter-spacing: 2px; margin-left: 6px; font-weight: 800; color: #3E4F7A;">
            碼雲登錄
          </div>
        </div>

        <!-- 右側標語 -->
        <div style="text-align: right;">
          <div style="color: #3E4F7A; font-size: 13px; margin-top: 6px;">
            技術驅動商業進化
          </div>
        </div>
      </div>
    </div>

    <div class="login-wrapper" style="margin-top: 180px;">
      <!-- 頁面主體內容 -->
      <div class="page-title">
        <h1 style="color: #3E4F7A;" v-if="activeTab === 'login'">登錄</h1>
        <h1 style="color: #3E4F7A;" v-if="activeTab === 'register'">註冊</h1>
        <!-- <p style="color: rgba(62, 79, 122, 0.8);">Sign in or create an account</p> -->
      </div>

      <!-- 切換卡片 -->
      <div class="card-container">
        <div class="card-tabs">
          <!-- 關鍵修復：正確綁定點擊事件並統一Active狀態 -->
          <button 
            :class="{'active': activeTab === 'login'}" 
            @click="switchTab('login')"
            :disabled="isTransitioning"
            style="color: #3E4F7A; border-bottom: 2px solid transparent;"
          >
            登錄
          </button>
          <button 
            :class="{'active': activeTab === 'register'}" 
            @click="switchTab('register')"
            :disabled="isTransitioning"
            style="color: #3E4F7A; border-bottom: 2px solid transparent;"
          >
            註冊
          </button>
        </div>

        <!-- 表單容器 -->
        <div class="form-container">
          <!-- 登錄表單 -->
          <transition name="fade" mode="out-in">
            <div class="form-card-inner" v-show="activeTab === 'login'">
              <el-form ref="loginForm" :model="loginForm" :rules="loginRules">
                <el-form-item prop="username">
                  <el-input 
                    v-model="loginForm.username" 
                    prefix-icon="el-icon-user" 
                    placeholder="請輸入用戶名"
                    style="border-color: #e4e7ed; color: #3E4F7A;"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input 
                    v-model="loginForm.password" 
                    prefix-icon="el-icon-lock" 
                    type="password"
                    placeholder="請輸入密碼"
                    style="border-color: #e4e7ed; color: #3E4F7A;"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button 
                    type="primary" 
                    @click="handleLogin"
                    style="background-color: #409EFF; border-color: #409EFF; width: 100%;"
                  >登錄</el-button>
                </el-form-item>
              </el-form>
            </div>
          </transition>

          <!-- 註冊表單 -->
          <transition name="fade" mode="out-in">
            <div class="form-card-inner" v-show="activeTab === 'register'">
              <el-form ref="registerForm" :model="registerForm" :rules="registerRules">
                <el-form-item prop="username">
                  <el-input 
                    v-model="registerForm.username" 
                    prefix-icon="el-icon-user" 
                    placeholder="請輸入用戶名"
                    style="border-color: #e4e7ed; color: #3E4F7A;"
                  ></el-input>
                </el-form-item>
                <!-- <el-form-item prop="email">
                  <el-input 
                    v-model="registerForm.email" 
                    prefix-icon="el-icon-message" 
                    placeholder="請輸入郵箱"
                    style="border-color: #e4e7ed; color: #3E4F7A;"
                  ></el-input>
                </el-form-item> -->
                <el-form-item prop="password">
                  <el-input 
                    v-model="registerForm.password" 
                    prefix-icon="el-icon-lock" 
                    type="password"
                    placeholder="請輸入密碼"
                    style="border-color: #e4e7ed; color: #3E4F7A;"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="confirmPassword">
                  <el-input 
                    v-model="registerForm.confirmPassword" 
                    prefix-icon="el-icon-lock" 
                    type="password"
                    placeholder="請確認密碼"
                    style="border-color: #e4e7ed; color: #3E4F7A;"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button 
                    type="primary" 
                    @click="handleRegister"
                    style="background-color: #409EFF; border-color: #409EFF; width: 100%;"
                  >註冊</el-button>
                </el-form-item>
              </el-form>
            </div>
          </transition>
        </div>
      </div>

      <!-- 頁腳 -->
      <div class="page-footer" style="color: #909399;">
        <p>© 2025 碼雲科技版權所有</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginPage',
  data() {
    return {
     activeTab: 'login',
      currentTab: 'login',
      isTransitioning: false,
      rememberMe: false,
      loginForm: { username: '', password: '' },
      registerForm: { username: '', email: '', password: '', confirmPassword: '' },
      
      loginRules: {
        username: [
          { required: true, message: '請輸入賬號', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '請輸入密碼', trigger: 'blur' },
        ]
      },
      registerRules: {
        username: [
          { required: true, message: '請輸入賬號', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '請輸入密碼', trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true, message: '請再次輸入密碼', trigger: 'blur' },
        ]
      }
    }
  },
  mounted() {
    // 頁面加載動畫
    this.$nextTick(() => {
      document.querySelector('.login-wrapper').classList.add('loaded');
    });
  },
  methods: {
    // 返回主頁方法
    goHome() {
      this.$router.push({ name: 'Home' })
    },
    
    // 切換選項卡
    switchTab(tab) {
      if (this.activeTab === tab || this.isTransitioning) return;
      
      this.isTransitioning = true;
      this.activeTab = tab;
      
      // 等待淡出動畫完成後再切換表單
      setTimeout(() => {
        this.currentTab = tab;
        // 重置表單
        if (tab === 'login') {
          this.resetRegisterForm();
        } else {
          this.resetLoginForm();
        }
        // 允許再次切換
        setTimeout(() => {
          this.isTransitioning = false;
        }, 100);
      }, 300);
    },
    
    // 登錄處理
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.$message({
            message: 'Login successful!',
            type: 'success'
          });
          // 模擬登錄請求
          setTimeout(() => {
            console.log('Login info:', this.loginForm);

            localStorage.setItem("LOGINED", "USER")

            this.$router.push({ name: 'Home' })
          }, 1000);
        } else {
          this.$message({
            message: 'Please check your input',
            type: 'warning'
          });
          return false;
        }
      });
    },
    
    // 註冊處理
    handleRegister() {
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          this.$message({
            message: 'Registration successful! Please login.',
            type: 'success'
          });
          // 模擬註冊請求
          setTimeout(() => {
            console.log('Registration info:', this.registerForm);
            this.switchTab('login');
          }, 1000);
        } else {
          this.$message({
            message: 'Please check your input',
            type: 'warning'
          });
          return false;
        }
      });
    },
    
    // 驗證確認密碼
    validateConfirmPassword(rule, value, callback) {
      if (value !== this.registerForm.password) {
        callback(new Error('Passwords do not match'));
      } else {
        callback();
      }
    },
    
    // 重置登錄表單
    resetLoginForm() {
      if (this.$refs.loginForm) {
        this.$refs.loginForm.resetFields();
      }
    },
    
    // 重置註冊表單
    resetRegisterForm() {
      if (this.$refs.registerForm) {
        this.$refs.registerForm.resetFields();
      }
    }
  }
}
</script>

<style scoped>

/* 基礎樣式 */
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  position: relative;
  /* background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%); */
  min-height: 100vh;
}

.login-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background-image: url('https://picsum.photos/id/1048/1920/1080'); */
  background-size: cover;
  background-position: center;
  opacity: 0.1;
  z-index: 0;
}

.login-wrapper {
  width: 100%;
  max-width: 420px;
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease, transform 0.6s ease;
  position: relative;
  z-index: 1;
}

.login-wrapper.loaded {
  opacity: 1;
  transform: translateY(0);
}

/* 新增頭部樣式 */
.header-container {
  background-color: white;
  padding: 16px 20px;
  border-radius: 10px;
  margin-bottom: 25px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.back-icon {
  width: 20px;
  height: 20px;
}

.header-title {
  font-size: 24px;
  letter-spacing: 2px;
  margin-left: 6px;
  font-weight: 800;
  color: #3E4F7A;
  line-height: 1.2;
}

.header-right {
  text-align: right;
}

.header-slogan {
  color: rgba(62, 79, 122, 0.8);
  font-size: 13px;
  margin-top: 6px;
}

/* 標題樣式 */
.page-title {
  text-align: center;
  margin-bottom: 30px;
  color: black;
}

.page-title h1 {
  font-size: 32px;
  margin-bottom: 10px;
  font-weight: 300;
  letter-spacing: 2px;
}

.page-title p {
  font-size: 16px;
  color: black;
}

/* 卡片樣式 */
.card-container {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.card-tabs {
  display: flex;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.card-tabs button {
  flex: 1;
  padding: 18px 0;
  background: transparent;
  border: none;
  color: black;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  outline: none;
}

.card-tabs button:hover:not(:disabled) {
  color: black;
}

.card-tabs button.active {
  color: black;
  font-weight: 500;
}

.card-tabs button.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, #4facfe 0%, #00f2fe 100%);
}

.card-tabs button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 表單容器 */
.form-container {
  min-height: 380px;
  position: relative;
  overflow: hidden;
}

.form-card-inner {
  padding: 25px 30px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
}

/* 表單樣式 */
.el-form-item {
  margin-bottom: 20px;
}

.el-input__inner {
  height: 44px;
  line-height: 44px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: white;
  transition: all 0.3s ease;
}

.el-input__inner::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.el-input__inner:hover {
  border-color: rgba(255, 255, 255, 0.3);
}

.el-input__inner:focus {
  border-color: #4facfe;
  box-shadow: 0 0 0 2px rgba(79, 172, 254, 0.2);
}

.el-input__prefix {
  color: rgba(255, 255, 255, 0.5);
}

.el-checkbox__label {
  color: rgba(255, 255, 255, 0.7);
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #4facfe;
  border-color: #4facfe;
}

.el-checkbox__inner {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

/* 按鈕樣式 */
.el-button {
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.el-button--primary {
  background: linear-gradient(90deg, #4facfe 0%, #00f2fe 100%);
  border: none;
  color: white;
  box-shadow: 0 4px 12px rgba(79, 172, 254, 0.3);
}

.el-button--primary:hover {
  background: linear-gradient(90deg, #4facfe 0%, #00f2fe 80%);
  box-shadow: 0 6px 16px rgba(79, 172, 254, 0.4);
  transform: translateY(-1px);
}

.el-button--primary:active {
  transform: translateY(1px);
}

.el-button--default {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
}

.el-button--default:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  color: white;
}

/* 頁腳樣式 */
.page-footer {
  text-align: center;
  margin-top: 20px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
}

/* 過渡動畫 */
/* .fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
} */

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

/* 表單驗證樣式 */
.el-form-item__error {
  color: #ff4d4f;
  font-size: 12px;
  padding-top: 4px;
}

/* 響應式調整 */
@media (max-width: 480px) {
  .login-wrapper {
    max-width: 90%;
  }
  
  .header-container {
    padding: 14px 16px;
  }
  
  .header-title {
    font-size: 22px;
  }
  
  .header-slogan {
    font-size: 12px;
  }
  
  .form-container {
    min-height: 360px;
  }
  
  .form-card-inner {
    padding: 20px;
  }
  
  .el-form-item {
    margin-bottom: 18px;
  }
  
  .el-button {
    padding: 10px 18px;
  }
  
  .page-title h1 {
    font-size: 28px;
  }
  
  .page-title p {
    font-size: 14px;
  }
}
</style>  